<template>
  <div class="cd_logo-container">
    <div class="cd_logo">
      <router-link :to="{ name: 'index' }" title="Home">
        <span class="sr-only">Creekdog</span>
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Logo'
  }
</script>
